import {IFetchContext} from "@pg-mono/data-fetcher";
import {appendQueryString} from "@pg-mono/request";
import {enable301ResponseState} from "@pg-mono/response-state";
import {IRankingAnnualParams, rpAppLink} from "@pg-mono/rp-routes";

import {rpApi} from "../../app/api/rp_api";
import {IRPStore} from "../../app/rp_reducer";
import {IRPRequestMeta} from "../../app/rp_request_meta";
import {fetch404Redirect} from "../../errors/actions/page_404_actions";
import {getOfferDetailList} from "../../offer/api/get_offer_detail_list";
import {getRegionDetailListApi} from "../../region/api/get_region_detail_list";
import {getRegionDetailListBySlug} from "../../region/api/get_region_detail_list_by_slug";
import {getRegionListApi} from "../../region/api/get_region_list";
import {IAppDispatch} from "../../store/store";
import {setViewTypeAction} from "../../view_type/actions/set_view_type_action";
import {ViewType} from "../../view_type/ViewType";
import {rankingLastYear} from "../constants/ranking";
import {getRankingCitiesIdByYear} from "../utils/get_ranking_cities_ids";
import {getRankingItems} from "../utils/get_ranking_items";
import {updateRankingListMetaDataYear} from "./update_ranking_meta_data";

export const rankingArchivedYearViewAction =
    (ctx: IFetchContext<IRPRequestMeta, IRankingAnnualParams>) => async (dispatch: IAppDispatch, _getState: () => IRPStore) => {
        const {citySlug, year} = ctx.match.params;
        const searchedRegions = await dispatch(getRegionDetailListBySlug.endpoints.getRegionDetailListBySlug.initiate({slug: citySlug}));
        const currentRegion = searchedRegions?.data?.results.length ? searchedRegions.data.results[0] : null;

        const lastYearRedirect = rpAppLink.ranking.lastYearList({
            citySlug
        });

        if (!currentRegion || year === rankingLastYear.toString()) {
            dispatch(enable301ResponseState(lastYearRedirect));
            return false;
        }

        const cities = getRankingCitiesIdByYear();
        const foundRankingCity = cities.find((cityId) => cityId === currentRegion.id);

        if (!foundRankingCity) {
            // TODO rewrite to rtk?
            const redirectUrl = (await fetch404Redirect(ctx.route.pathname, ctx.meta)) ?? appendQueryString(rpAppLink.ranking.base(), ctx.route.query);
            dispatch(enable301ResponseState(redirectUrl));
            return false;
        }

        const rankingItems = getRankingItems(currentRegion.id, year);

        const offerIds = rankingItems ? rankingItems.map((item) => item.offerId) : [];
        await dispatch(getOfferDetailList.endpoints.getOfferDetailList.initiate({offerIds}));
        await dispatch(getRegionListApi.endpoints.getRegionList.initiate({region: cities}));
        await dispatch(getRegionDetailListApi.endpoints.getRegionDetailList.initiate({regionIds: cities}));
        const region = await dispatch(getRegionDetailListBySlug.endpoints.getRegionDetailListBySlug.initiate({slug: citySlug})).unwrap();

        await Promise.all(dispatch(rpApi.util.getRunningQueriesThunk()));

        dispatch(setViewTypeAction(ViewType.OFFER_RANKING));
        dispatch(updateRankingListMetaDataYear(ctx, region.results[0], year));
    };
import {IFetchContext} from "@pg-mono/data-fetcher";
import {appendQueryString} from "@pg-mono/request";
import {enable301ResponseState} from "@pg-mono/response-state";
import {IRankingAnnualParams, rpAppLink} from "@pg-mono/rp-routes";

import {rpApi} from "../../app/api/rp_api";
import {IRPStore} from "../../app/rp_reducer";
import {IRPRequestMeta} from "../../app/rp_request_meta";
import {fetch404Redirect} from "../../errors/actions/page_404_actions";
import {getOfferDetailList} from "../../offer/api/get_offer_detail_list";
import {getRegionDetailListApi} from "../../region/api/get_region_detail_list";
import {getRegionDetailListBySlug} from "../../region/api/get_region_detail_list_by_slug";
import {getRegionListApi} from "../../region/api/get_region_list";
import {IAppDispatch} from "../../store/store";
import {setViewTypeAction} from "../../view_type/actions/set_view_type_action";
import {ViewType} from "../../view_type/ViewType";
import {rankingLastYear} from "../constants/ranking";
import {getRankingCitiesIdByYear} from "../utils/get_ranking_cities_ids";
import {getRankingItems} from "../utils/get_ranking_items";
import {updateRankingListMetaDataYear} from "./update_ranking_meta_data";

export const rankingArchivedYearViewAction =
    (ctx: IFetchContext<IRPRequestMeta, IRankingAnnualParams>) => async (dispatch: IAppDispatch, _getState: () => IRPStore) => {
        const {citySlug, year} = ctx.match.params;
        const searchedRegions = await dispatch(getRegionDetailListBySlug.endpoints.getRegionDetailListBySlug.initiate({slug: citySlug}));
        const currentRegion = searchedRegions?.data?.results.length ? searchedRegions.data.results[0] : null;

        const lastYearRedirect = rpAppLink.ranking.lastYearList({
            citySlug
        });

        if (!currentRegion || year === rankingLastYear.toString()) {
            dispatch(enable301ResponseState(lastYearRedirect));
            return false;
        }

        const cities = getRankingCitiesIdByYear();
        const foundRankingCity = cities.find((cityId) => cityId === currentRegion.id);

        if (!foundRankingCity) {
            // TODO rewrite to rtk?
            const redirectUrl = (await fetch404Redirect(ctx.route.pathname, ctx.meta)) ?? appendQueryString(rpAppLink.ranking.base(), ctx.route.query);
            dispatch(enable301ResponseState(redirectUrl));
            return false;
        }

        const rankingItems = getRankingItems(currentRegion.id, year);

        const offerIds = rankingItems ? rankingItems.map((item) => item.offerId) : [];
        await dispatch(getOfferDetailList.endpoints.getOfferDetailList.initiate({offerIds}));
        await dispatch(getRegionListApi.endpoints.getRegionList.initiate({region: cities}));
        await dispatch(getRegionDetailListApi.endpoints.getRegionDetailList.initiate({regionIds: cities}));
        const region = await dispatch(getRegionDetailListBySlug.endpoints.getRegionDetailListBySlug.initiate({slug: citySlug})).unwrap();

        await Promise.all(dispatch(rpApi.util.getRunningQueriesThunk()));

        dispatch(setViewTypeAction(ViewType.OFFER_RANKING));
        dispatch(updateRankingListMetaDataYear(ctx, region.results[0], year));
    };
